export default "__VITE_ASSET__LdJfz93y__"